// extracted by mini-css-extract-plugin
module.exports = {"divider":"NewMessagesDivider_divider__7yxqt","badge":"NewMessagesDivider_badge__M8nEE"};